import { render, staticRenderFns } from "./CallsWithClients.vue?vue&type=template&id=9ad06f16&"
import script from "./CallsWithClients.vue?vue&type=script&lang=js&"
export * from "./CallsWithClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports